import LegacyView from './LegacyView';

// meta.legacyView is the migration switch: a route carrying it is rendered by the legacy iframe
// (the bridge publishes evtChangeView with that view). Converting a screen to Vue = give the route
// a real component and drop meta.legacyView — nothing else has to change.
//
// meta.appMenu     default appMenu when no legacy payload was recorded for the URL (cold start).
// meta.coldStart   the legacy opens this view from its own menu with data: null, so a reload or a
//                  pasted URL can be replayed through the AUTOLOAD cookie (see legacyNavigationBridge).
// meta.aliases     other legacy view names that render the same screen.
// meta.historyMode 'replace' for transient views that must never create history entries.
const legacyRoute = (path, name, legacyView, appMenu, extra = {}) => ({ path, name, component: LegacyView, meta: { legacyView, appMenu, ...extra } });

export const routes = [
	legacyRoute('/', 'Home', 'widgets', 'menuHome', { aliases: ['vwWidgets'] }),
	legacyRoute('/agenda', 'Agenda', 'vwSFAPlanning', 'menuAgenda', { coldStart: true }),
	legacyRoute('/pos', 'MyPos', 'vwSFAPOS', 'menuMyPOS', { coldStart: true }),
	legacyRoute('/visit/:uid?', 'Visit', 'vw-visit', 'menuSFA'),
	legacyRoute('/sfa', 'SfaHome', 'vwSFAEdito', 'menuSFA'),
	legacyRoute('/sfa/promo', 'SfaPromo', 'vwSFAPromo', 'menuSFA', { coldStart: true }),
	legacyRoute('/sfa/objectives', 'SfaObjectives', 'vwDocObjectives', 'menuSFA', { coldStart: true }),
	legacyRoute('/sfa/watch', 'SfaWatch', 'vwWatch', 'menuSFA', { coldStart: true }),
	legacyRoute('/sales', 'SalesHome', 'vwSalesEdito', 'menuSFA', { coldStart: true }),
	legacyRoute('/sales/catalog', 'SalesCatalog', 'vwSalesCatalog', 'menuSALES', { coldStart: true }),
	legacyRoute('/sales/catalog/return', 'SalesCatalogReturn', 'vwSalesCatalogReturn', 'menuSALES', { coldStart: true }),
	legacyRoute('/sales/cart', 'SalesCart', 'vwSalesCartForm', 'menuSALES'),
	legacyRoute('/sales/cart/validation', 'SalesCartValidation', 'vwSalesCartFormValidation', 'menuSALES'),
	legacyRoute('/sales/orders', 'Orders', 'vwOrdersTracking', 'menuSALES', { coldStart: true }),
	legacyRoute('/sales/orders/validation', 'OrdersValidation', 'vwOrdersValidation', 'menuSALES', { coldStart: true }),
	legacyRoute('/sales/orders/statement', 'OrdersStatement', 'vwOrdersStatement', 'menuSALES', { coldStart: true }),
	legacyRoute('/sales/orders/assort/:orderId?', 'OrdersAssort', 'vwOrdersTrackingAssort', 'menuSALES', { coldStart: true }),
	legacyRoute('/docs', 'DocsHome', 'vwDocEdito', 'menuDOC', { coldStart: true }),
	legacyRoute('/docs/folders/:folderId?', 'DocFolders', 'vwDocFolders', 'menuDOC', { coldStart: true }),
	legacyRoute('/docs/watch', 'DocWatch', 'vwVeille', 'menuDOC', { coldStart: true }),
	legacyRoute('/docs/search', 'DocSearch', 'vwDocSearch', 'menuDOC', { historyMode: 'replace' }),
	// SSOHandler.vue is deliberately not routed: Startup.js answers SSO_AUTH without a redirectUrl,
	// so mounting it parks the app on /auth. The cookies ssoPostHandler already set drive the login.
	{ path: '/auth', name: 'SSOAuth', redirect: '/' },
	{ path: '/:pathMatch(.*)*', name: 'NotFound', redirect: '/' },
];
